import { Component, OnInit } from '@angular/core';
import { memberPerkService } from '../../Services/memberPerk.service';
import { AuthService } from '../../Services/auth.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-member-perks-admin',
  template: require('./member-perks-admin.component.html'),
  styles: [require('./member-perks-admin.component.css')]
})
export class MemberPerksAdminComponent implements OnInit {
  data : any[] = [];
  editId: number = 0;
  perkBody: string='';
  newSponsor: string='';
  perk: any = {}; 
  

  constructor(private memberPerkService: memberPerkService, private auth: AuthService) { }

  ngOnInit() {
    this.loadPerks()
  }
  
  resetPerk(){
    this.editId = 0;
    this.newSponsor = "";
    this.perkBody = "";
  }

  loadPerks(){
    this.memberPerkService.getAllPerks().subscribe( res =>{
      if (res.status == 200){
        this.data = res.value 
        // console.log(this.data);
        
      }
      
    })
  }

  editPerk(id: number){
    this.perk = this.data.find( (s:any) => s.id == id)
    this.editId = this.perk.id;
    this.perkBody = this.perk.content;
    this.newSponsor = this.perk.sponsor; 
  }

  deletePerk(id: number){
    Swal.fire({
                title: 'Ben je zeker?',
                text: "Ben je zeker dat je dit voordeel wil verwijderen?",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Jep',
                cancelButtonText: 'Nope'
              }).then((result) => {
                if (result.value) {
                  this.memberPerkService.deletePerk(id).subscribe(x => {
                    this.loadPerks();
                  })
                }
              });
  }

  SavePerk(){
    this.perk.id = this.editId;
    this.perk.sponsor = this.newSponsor;
    this.perk.content = this.perkBody;
    console.log(this.perk);
    
    if (this.editId > 0){
      console.log("updating .... ");
      this.memberPerkService.updatePerk(this.perk).subscribe( res =>{
        if (res.status == 200){
          console.log("success");
        }
      })
      
    }else{
      this.memberPerkService.createNewPerk(this.perk).subscribe( res =>{
        if (res.status == 200){
          console.log("success");
        }
      
      })

    }
  }

 
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/member-perks-admin/member-perks-admin.component.ts